import { render, staticRenderFns } from "./MatterProgramEvaluation.vue?vue&type=template&id=65bcd22c&scoped=true"
import script from "./MatterProgramEvaluation.vue?vue&type=script&lang=js"
export * from "./MatterProgramEvaluation.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=65bcd22c&prod&scoped=true&lang=css&external"
import style1 from "./MatterProgramEvaluation.vue?vue&type=style&index=1&id=65bcd22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bcd22c",
  null
  
)

export default component.exports